import UsfImage from "../images/ons-main.png";

export function Header(): JSX.Element {
  return (
    <div style={{ backgroundImage: `url(${UsfImage})` }} className="h-[80vh] flex flex-col items-center justify-center bg-cover bg-no-repeat bg-center">
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      <h1 className="text-8xl font-bold text-usfLightGrey mb-4 z-10">Welcome to ONS</h1>
      <h2 className="text-5xl font-bold text-usfLightGrey z-10">Envision. Engage. Excel.</h2>
    </div>
  )
}
